// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__IkTtq","red":"Layout_red__C6pRA","white":"Layout_white__AaO1r"};